import { EmblaCarouselType } from "embla-carousel";

type HTMLMBtnType = HTMLElement | null;

/**
 * Actives Prev / Next
 */
export const addTogglePrevNextBtnsActive = (
  emblaApi: EmblaCarouselType,
  { prevBtn, nextBtn }: { prevBtn?: HTMLMBtnType; nextBtn?: HTMLMBtnType },
) => {
  const togglePrevNextBtnsState = () => {
    if (emblaApi.canScrollPrev()) prevBtn?.removeAttribute("disabled");
    else prevBtn?.setAttribute("disabled", "disabled");

    if (emblaApi.canScrollNext()) nextBtn?.removeAttribute("disabled");
    else nextBtn?.setAttribute("disabled", "disabled");
  };

  emblaApi
    .on("select", togglePrevNextBtnsState)
    .on("init", togglePrevNextBtnsState)
    .on("reInit", togglePrevNextBtnsState);

  return () => {
    prevBtn?.removeAttribute("disabled");
    nextBtn?.removeAttribute("disabled");
  };
};

/**
 * Buttons Prev / Next
 */
export const addPrevNextBtnsClickHandlers = (
  emblaApi: EmblaCarouselType,
  { prevBtn, nextBtn }: { prevBtn?: HTMLMBtnType; nextBtn?: HTMLMBtnType },
) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev();
  };
  const scrollNext = () => {
    emblaApi.scrollNext();
  };
  prevBtn?.addEventListener("click", scrollPrev, false);
  nextBtn?.addEventListener("click", scrollNext, false);

  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(emblaApi, { prevBtn, nextBtn });

  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn?.removeEventListener("click", scrollPrev, false);
    nextBtn?.removeEventListener("click", scrollNext, false);
  };
};

/**
 * Bullets
 */
export const addDotBtnsAndClickHandlers = (
  emblaApi: EmblaCarouselType,
  { dotsNode, selector = "c-slider-pagination__dot" }: { dotsNode: HTMLElement | null; selector?: string },
) => {
  if (!dotsNode) {
    console.warn("Dots node is not provided");
    return () => {};
  }

  let dotNodes: HTMLElement[] = [];

  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => `<button class="${selector}" type="button"></button>`)
      .join("");

    const scrollTo = (index: number) => {
      emblaApi.scrollTo(index);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll(`.${selector}`));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => scrollTo(index), false);
    });
  };

  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    dotNodes[previous].classList.remove(`${selector}--selected`);
    dotNodes[selected].classList.add(`${selector}--selected`);
  };

  emblaApi
    .on("init", addDotBtnsWithClickHandlers)
    .on("reInit", addDotBtnsWithClickHandlers)
    .on("init", toggleDotBtnsActive)
    .on("reInit", toggleDotBtnsActive)
    .on("select", toggleDotBtnsActive);

  return () => {
    dotsNode.innerHTML = "";
  };
};
